import { mapStateToInputSectionProps } from "./components/PaymentSelection/components/PaymentDetailsSection/InputSection";
import { mapStateToPaymentMethodSectionProps } from "./components/PaymentSelection/components/PaymentMethodSection";
import { mapStateToRequestStatusProps } from "./components/Popups/RequestStatus";
import { mapStateToSberPayModalProps } from "./components/Popups/SberPayModal";
import { getMapStateToPaymentContainerProps } from "./logic/logic";
import { getContent } from "../../dependencies/getContent/dev";
import { getIsLoggedIn } from "../../dependencies/getIsLoggedIn/dev";
import { getModalComponent } from "../../dependencies/getModalComponent/dev";
import { initialize } from "../../dependencies/initialize/dev";
import { getUserAccountInfo } from "../../dependencies/getUserAccountInfo/dev";
import { getWindow } from "../../../utils/window";
import { checkUrl } from "../../dependencies/checkUrl/dev";
import { mapStateToHeaderButtonsProps } from "../HeaderButtons";
import { mapStateToSBPModalProps } from "./components/Popups/SBPModal";
import { mapStateToSMSConfirmationPopupProps } from "./components/Popups/SMSConfirmationPopup";
import { mapStateToEmailPopupProps } from "./components/Popups/EmailPopup";

/**
 * Set up dependencies for the payment widget state mapping.
 *
 * NOTE: Index files are responsible for connecting dependencies to their respective logic
 * This approach uses a hierarchical composition pattern, where dependencies are organized
 * at the same level as their corresponding components. This keeps the codebase modular
 * and easier to maintain.
 * The top-level index.ts file gathers dependencies from the index.ts files of other components
 * and composes them following the same hierarchy as the components.
 * */
export var mapStateToPaymentContainerProps = getMapStateToPaymentContainerProps({
  getContent: getContent,
  initialize: initialize,
  mapStateToHeaderButtonsProps: mapStateToHeaderButtonsProps,
  mapStateToInputSectionProps: mapStateToInputSectionProps,
  mapStateToPaymentMethodSectionProps: mapStateToPaymentMethodSectionProps,
  mapStateToRequestStatusProps: mapStateToRequestStatusProps,
  mapStateToSBPModalProps: mapStateToSBPModalProps,
  mapStateToSberPayModalProps: mapStateToSberPayModalProps,
  getIsLoggedIn: getIsLoggedIn,
  getModalComponent: getModalComponent,
  mapStateToSMSConfirmationPopupProps: mapStateToSMSConfirmationPopupProps,
  checkUrl: checkUrl,
  getUserAccountInfo: getUserAccountInfo,
  mapStateToEmailPopupProps: mapStateToEmailPopupProps,
  getWindow: getWindow
});